import { useState } from "react";

import { Locale } from "date-fns";
import { sv } from "date-fns/locale";

import CalendarIcon from "@/assets/icons/calendar.svg";
import { reverseDateRange } from "@/views/MentionsView/partials/DateRangeButton/ranges";
import Range, {
  DateRangePreset,
  RangeProps,
} from "@components/DatePicker/Range";
import Adornment from "@components/Field/Adornment";
import * as Popover from "@radix-ui/react-popover";

import FauxField, { FauxFieldProps } from "../FauxField";

import dateStyles from "./DateRange.module.css";

export type DateRangeFieldProps = {
  locale?: Locale;
  value?: { startDate?: Date; endDate?: Date } | undefined;
  ranges?: DateRangePreset[];
  formatPretty?: (date: Date) => string;
} & Omit<FauxFieldProps, "onChange"> &
  Pick<RangeProps, "onChange">;

const DateRangeField: React.FunctionComponent<DateRangeFieldProps> = ({
  onChange,
  locale = sv,
  ranges = [],
  value = {},
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const defaultRange = ranges.find((r) => r.default);
  const { startDate, endDate } = value;

  const rangeLabel = reverseDateRange(
    startDate ? startDate : undefined,
    endDate ? endDate : undefined,
    locale,
    ranges
  )?.label;

  return (
    <Popover.Root
      open={open}
      onOpenChange={(newOpen) => setOpen(newOpen)}
      modal
    >
      <Popover.Trigger asChild>
        <FauxField
          placeholder={rangeLabel}
          endAdornment={
            <Adornment position="end">
              <CalendarIcon />
            </Adornment>
          }
          {...props}
        />
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          className={dateStyles.popover}
          sideOffset={5}
          side="bottom"
          align="start"
        >
          <div>
            <Range
              startDate={startDate ? startDate : defaultRange?.startDate}
              endDate={endDate ? endDate : defaultRange?.endDate}
              settings={{
                locale,
                // ...settings,
              }}
              presets={ranges}
              onChange={(dates, fromPreset) => {
                if (fromPreset) {
                  setOpen(false);
                }
                onChange(dates);
              }}
            />
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
};

export default DateRangeField;
